import {connect} from 'react-redux'
import RichHeader from './RichHeader.jsx';
import MainFooter from '../../components/footers/Original_Main.jsx'
import SideBar from '../../components/affix/SideBar.jsx';
import AgFullBanner from '../../components/banner/AgFullBanner-hy.jsx';
import Popup from '../../components/modal/popup.jsx'
import Bulletins from '../pc-day/fragment/Bulletins.jsx'
import Marquee from "../../components/tools/Marquee-hy.jsx";
import {DISABLE_LOTTERY_IDS} from '../../constants/lotterys/config'
import {LOTTERY_MENUS} from '../../constants/menus/lotteryMenus'
import {DOMAIN} from '../../constants/config'
import {BROWSER_DOWNLOAD} from '../../constants/config';
import RecommendAds from './RecommendAds';
import * as UNIT from '../../helpers/unit.js';
import banner0 from '../../i/pc-day/hy/banner0.jpg'
import banner1 from '../../i/pc-day/hy/banner1.png'
import banner2 from '../../i/pc-day/hy/banner2.png'
import banner3 from '../../i/pc-day/hy/banner3.png'
import banner4 from '../../i/pc-day/hy/banner4.png'
import awardSource from '../../i/pc-day/hy/hy-award-source.png'
import Manycai from '../../i/pc-day/hy/manycai.png'
import Proxys from '../../i/pc-day/hy/proxy.png';
import Proxy2 from '../../i/pc-day/hy/proxy-2.png'

class Home extends React.Component {

  constructor(props) {
    super(props);
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.openNotice = this.openNotice.bind(this);
    this.toastFn = this.toastFn.bind(this);
    this.openNoticePopup = this.openNoticePopup.bind(this);
    this.closeNovicePopup = this.closeNovicePopup.bind(this);
    this.hideNoviceTask = this.hideNoviceTask.bind(this);
    this.hideBrowserTask = this.hideBrowserTask.bind(this);
    this.state = {
      notice: [],
      showNotice: false,
      popup: '',
      showNovice: false,
      noviceTaskOrigin: true,
      noviceBrowserOrigin: true,
      hideTaskView: false,
      hideBrowserView: false
      // banners: []
    }
  }

  componentDidMount() {

    // 获取第一页公告信息
    this.props.$$COMMON.getBulletins(1);

    // 获取首页banner图
    this.props.$$COMMON.getBanners(1);

    // let banners = [
    //       {
    //           end_time: "2021-11-19",
    //           link: "javascript:void()",
    //           picture: banner0,
    //           sort: "0",
    //           start_time: "2018-11-01",
    //           title: "支付宝充值,七天免手续费",
    //       },
    //       {
    //           end_time: "2021-11-19",
    //           link: "javascript:void()",
    //           picture: banner4,
    //           sort: "0",
    //           start_time: "2018-11-01",
    //           title: "上线",
    //       },
    //       {
    //           end_time: "2021-11-19",
    //           link: "http://nh.hygame188.vip",
    //           picture: banner2,
    //           sort: "0",
    //           start_time: "2017-11-22",
    //           title: "南海之行",
		//       }
    //       // ,
    //       // {
    //       //     end_time: "2021-11-19",
    //       //     link: "http://www.hygame188.vip",
    //       //     picture: banner3,
    //       //     sort: "0",
    //       //     start_time: "2018-11-01",
    //       //     title: "日本游",
    //       // }
    //   ];
    // this.setState({banners});

    // 获取彩种销售情况
    this.props.$$LOTTERY.getLotterySaleInfo();

    $.scroll2Top();


    this.noviceTimer = setTimeout(() => this.setState({noviceTaskOrigin: false, noviceBrowserOrigin: false}), 1500)

  }

  hideNoviceTask() {
    this.setState({
      hideTaskView: !this.state.hideTaskView
    })
  }

  hideBrowserTask(){
    this.setState({
      hideBrowserView: !this.state.hideBrowserView
    })
  }

  componentWillUnmount() {
    if (this.noviceTimer) clearTimeout(this.noviceTimer);
  }

  // 关闭公告弹窗
  closePopup() {
    this.setState({
      showNotice: false,
    })
  }

  // 打开公告弹窗
  openPopup(num) {
    this.setState({
      showNotice: true,
      popup: num
    })

  }

  //打开新手任务弹窗
  openNoticePopup() {
    this.setState({
      showNovice: true
    })
  }

  //打开新手任务弹窗
  closeNovicePopup() {
    this.setState({
      showNovice: false
    })
  }

  // 打开小提示
  toastFn(message) {
    this.props.$$BASE.openToast(message);
  }


  // 跳转活动或者公告
  openNotice(notice) {
    this.setState({
      _notice: notice,
      showNotice: true
    })
  }

  componentWillReceiveProps(nextProps) {
    // 公告
    const bulletins = nextProps.__COMMON.toJS().bulletins.list;
    if (bulletins.length > 0 && this.state.notice.length == 0) {
      this.setState({
        notice: _.chain(bulletins).orderBy(['created_at'], ['desc']).orderBy(['is_top'], ['desc']).filter((item, index) => index < 6).value(),
        showNotice: !bulletins[0].is_read,
        _notice: !bulletins[0].is_read ? bulletins[0] : null
      })
    }
  }

  render() {
    const __base = this.props.__BASE.toJS();
    const __common = this.props.__COMMON.toJS();
    const __lottery = this.props.__LOTTERY.toJS();
    const __user = this.props.__USER.toJS();
    const {noviceTaskOrigin, hideTaskView, hideBrowserView, noviceBrowserOrigin } = this.state;

    return (
        <div className={__base.ui.skin}>
          <div className='home-framework'>
            <RichHeader/>
            <RecommendAds />
            <SideBar hasClass="indexSideBar"/>
            <div className='banner-framework'>
              <AgFullBanner
                  className="agBox indexBanner"
                  list={__common.banners}
              />
            </div>
            <div className='content_bg'>
              <img src={awardSource} className="prize-cer" onClick={()=> window.open('http://www.manycai.com')}/>
              <img src={Manycai} className="manycai-icon" onClick={()=> window.open('/static/activity/manycai/index.html')}/>
              <img className='proxy' onClick={() => window.open('https://www.xnpfstudio.com/')} src={Proxys} />
              <img className='proxy-2' onClick={() => window.open('https://www.jdcfwealth.com/')} src={Proxy2} />
              <div className="notice">
                <Marquee scrollH={34} list={this.state.notice} onMore={(item) => {
                  this.openPopup(1)
                }}/>
              </div>
              <div className='home_cont cf'>
                <LotteryGames saleInfo={__lottery.sale_info}/>
              </div>
            </div>
            <MainFooter/>
            {/* 公告弹窗*/}
            <Popup display={this.state.showNotice} className="indexPobup" width={980} height={567}
                   onclose={this.closePopup}>
              <Bulletins notice={this.state._notice}/>
            </Popup>

            <div className={hideTaskView ? "novice-task-close" : ("novice-task " + (noviceTaskOrigin ? "novice-task-origin" : "novice-task-after"))}>
              <div className="open-novice" onClick={this.openNoticePopup.bind(this)}></div>
              <div className="close-novice" onClick={() => {
                this.hideNoviceTask()
              }}></div>
            </div>
            <div className={hideBrowserView ? "novice-task-close browser-close " : ("novice-task browser-task " + (noviceBrowserOrigin ? "novice-task-origin" : "novice-task-after"))}>
                <a href={BROWSER_DOWNLOAD.CHROME} target="_blank" className="browser-chrome"></a>
                <a href={BROWSER_DOWNLOAD.SOGOU} target="_blank" className="browser-sougou"></a>
                <a href={BROWSER_DOWNLOAD.FIREFOX} target="_blank" className="browser-firefox"></a>
              <div className="close-novice close-browser" onClick={() => {
                this.hideBrowserTask()
              }}></div>
            </div>
            <Popup className="novicePopup" display={this.state.showNovice} onclose={this.closeNovicePopup.bind(this)}
                   width={750} height={686}>
              <div className="pop-title-warp">
                <p className="pop-title">新手任务</p>
              </div>
              {
                __user.sessid ? <iframe className='noviceTask' height='640' width="750"
                                        src={DOMAIN + "default/getusertask"}/> : null
              }
            </Popup>
          </div>
        </div>
    );
  }
}

reactMixin(Home.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __COMMON: state.common,
    __LOTTERY: state.lottery,
    __USER: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$USER: bindActionCreators(userAction, dispatch),
    $$COMMON: bindActionCreators(commonAction, dispatch),
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch),
    $$GAME: bindActionCreators(gameAction, dispatch)
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Home)

// class HomeHotLottery extends React.Component {
//
//   constructor(props) {
//     super(props);
//     this.state = {
//       boxList: [{id: 28, info: null, menu: null, timeShow: '倒计时 : -- : -- : --', nearOpen: false},
//         {id: 19, info: null, menu: null, timeShow: '倒计时 : -- : -- : --', nearOpen: false},
//         {id: 29, info: null, menu: null, timeShow: '倒计时 : -- : -- : --', nearOpen: false},
//         {id: 26, info: null, menu: null, timeShow: '倒计时 : -- : -- : --', nearOpen: false},
//         {id: 27, info: null, menu: null, timeShow: '倒计时 : -- : -- : --', nearOpen: false}],
//     };
//     this.handlePlayClick = this.handlePlayClick.bind(this);
//     this.timeBoxReset = this.timeBoxReset.bind(this);
//   }
//
//   componentWillReceiveProps(nextProps) {
//     if (!nextProps.saleInfo || nextProps.saleInfo.length == 0) {
//       return
//     }
//     //拼接所有的彩种信息
//     let menuList = _.concat(..._.map(LOTTERY_MENUS, 'lotterys'));
//     //根据id 找到彩种的销售信息 以及 彩种信息
//     _.forEach(this.state.boxList, function (item, index) {
//       item.info = _.find(nextProps.saleInfo, {lotteryid: item.id});
//       item.menu = _.find(menuList, {lotteryId: item.id});
//     });
//     //开始倒计时
//     this.timeBoxReset(this.state.boxList);
//   }
//
//   componentWillUnmount() {
//     if (this.countdownTimer) {
//       window.clearInterval(this.countdownTimer)
//     }
//     ;
//   }
//
//   //开始倒计时
//   timeBoxReset(boxList) {
//     //如果有定时器，清除掉，以下会重新开启，重新开始计时
//     if (this.countdownTimer) {
//       window.clearInterval(this.countdownTimer)
//     }
//     ;
//
//     //定时任务 每秒倒计时
//     const intervalCountdown = () => {
//       _.forEach(boxList, (item, index) => {
//         let infoError = false;
//         let timeShow = "";
//
//         //如果没有彩种信息 获取 倒计时时间为空 不做任何处理，继续下个彩种的工作
//         if (!item.info) {
//           return;
//         }
//         //如果未到销售时间
//         if (!item.info.is_selling) {
//           infoError = true;
//           timeShow = "彩种未到销售时间";
//         }
//         //如果给的countdown 倒计时无效，显示  '倒计时 : -- : -- : --'
//         if (item.info.countdown == null || item.info.countdown == undefined || isNaN(item.info.countdown)) {
//           infoError = true;
//           timeShow = '倒计时 : -- : -- : --';
//         }
//
//         //没有销售周期，并且倒计时为0的时候，显示倒计时 00:00:00， 错误处理
//         if ((item.info.issue_cycle == null || isNaN(item.info.issue_cycle)) && (item.info.countdown <= 0 || isNaN(item.info.countdown))) {
//           infoError = true;
//           timeShow = "倒计时 00:00:00";
//         }
//
//         if (infoError) {
//           let listClone = _.cloneDeep(this.state.boxList);
//           listClone[index].timeShow = timeShow;
//           this.setState({
//             boxList: listClone
//           });
//           return;
//         }
//
//         //如果时间还没有那么时间减一，如果时间到了，则从开奖周期倒计时
//         item.info.countdown = item.info.countdown > 0 ? item.info.countdown - 1 : item.info.next_cycle;
//
//         //重新渲染时间
//         let timerGroup = $.formatTime(item.info.countdown).split(':');
//         let listClone = _.cloneDeep(this.state.boxList);
//         listClone[index].timeShow = "倒计时 " + timerGroup[0] + ":" + timerGroup[1] + ":" + timerGroup[2];
//         listClone[index].nearOpen = item.info.countdown <= 10;
//         this.setState({
//           boxList: listClone
//         });
//       });
//     };
//     //第一次马上显示出来时间，并开启定时器，开始倒计时
//     intervalCountdown();
//     this.countdownTimer = window.setInterval(intervalCountdown, 1000)
//   }
//
//   // 立即投注
//   handlePlayClick(item) {
//
//     const {toastFn} = this.props;
//     if (!item.info) {
//       toastFn('近期开放，敬请期待');
//       return;
//     }
//
//     let id = item.info.lotteryid;
//
//     if (this.props.saleInfo.length === 0) {
//       toastFn('数据加载中....');
//       return;
//     }
//     const _lottery = _.find(this.props.saleInfo, {lotteryid: id});
//     if (!_lottery.is_selling) {
//       toastFn('当前彩种未到销售时间');
//       return;
//     }
//     if (window.METHODS.autheError) {
//       toastFn(window.METHODS.autheError.message);
//       return;
//     }
//     // 临时屏蔽，敬请期待
//     if (_.includes(DISABLE_LOTTERY_IDS, id)) {
//       toastFn('近期开放，敬请期待');
//       return;
//     }
//     window.location.href = item.menu.uri;
//   }
//
//   render() {
//     const {list} = this.state;
//     return <div className="home-hot-lottery">
//       <div className="title"></div>
//       <ul>
//         {
//           this.state.boxList.map((item, index) => {
//             return <li onClick={() => {
//               this.handlePlayClick(item)
//             }} key={index}>
//               <a></a>
//               <p className="brand">{item.menu ? item.menu.name : ""}&emsp;</p>
//               <p className={item.nearOpen ? "timeOpening" : "timeNormal"}>{this.state.boxList[index].timeShow}</p>
//             </li>
//           })
//         }
//       </ul>
//     </div>
//   }
// }
//
// /*海外境内 热门彩票
// * */
// class OverseasLottery extends React.Component {
//   constructor(props) {
//     super(props);
//     this.overseaList = [{"id": 29}, {"id": 35}, {"id": 37}, {"id": 39}, {"id": 38}, {"id": 40}, {"id": 26}, {"id": 27}];
//     this.territoryList = [{"id": 28}, {"id": 41}, {"id": 42}, {"id": 24}, {"id": 25}, {"id": 1}, {"id": 15}, {"id": 23}];
//     this.itemClick = this.itemClick.bind(this);
//     //根据彩种ID找到 彩种的信息
//     for (let i = 0; i < this.overseaList.length; i++) {
//       this.overseaList[i].info = _.find(_.concat(..._.map(LOTTERY_MENUS, 'lotterys')), {lotteryId: this.overseaList[i].id});
//       this.territoryList[i].info = _.find(_.concat(..._.map(LOTTERY_MENUS, 'lotterys')), {lotteryId: this.territoryList[i].id});
//     }
//   }
//
//   itemClick(item) {
//     window.location.href = item.info.uri;
//   }
//
//   render() {
//     return <div className="home-oversea">
//       <div className="oversea-warp">
//         <div className="title"></div>
//         <div className="oversea">
//           <ul>
//             {
//               this.overseaList.map((item, index) => {
//                 return <li onClick={() => this.itemClick(item)} key={index}>{item.info.name}<i
//                     className={item.info.type}></i></li>
//               })
//             }
//           </ul>
//         </div>
//       </div>
//       <div className="teritory-warp">
//         <div className="title"></div>
//         <div className="territory">
//           <ul>
//             {
//               this.territoryList.map((item, index) => {
//                 return <li onClick={() => this.itemClick(item)} key={index}>{item.info.name}<i
//                     className={item.info.type}></i></li>
//               })
//             }
//           </ul>
//         </div>
//       </div>
//     </div>
//   }
// }
//
//
// //首页 游戏首页
// class HomeGame extends React.Component {
//
//   constructor(props) {
//     super(props)
//   }
//
//   render() {
//     return <div className="home-game">
//       <ul>
//         <li>
//           <div className="item">
//             <div className="title"></div>
//             <img onClick={() => window.location.href = "#/casino"}/>
//           </div>
//         </li>
//         <li>
//           <div className="item">
//             <div className="title"></div>
//             <img onClick={() => window.location.href = "#/slot"}/>
//           </div>
//         </li>
//         <li>
//           <div className="item">
//             <div className="title"></div>
//             <img onClick={() => window.location.href = "#/sports"}/>
//           </div>
//         </li>
//       </ul>
//     </div>
//   }
// }

/**
 * 彩票游戏
 */
class LotteryGames extends React.Component {

  constructor(props) {
    super(props);
    this.resetTimeState = this.resetTimeState.bind(this);
    this.handlePlayClick = this.handlePlayClick.bind(this);
    this.countdown = this.countdown.bind(this);
    this.state = {
      ydlpk: ['--', '--', '--'],
      xyft: ['--', '--', '--']
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.saleInfo || nextProps.saleInfo.length == 0) {
      return
    }
    if (JSON.stringify(nextProps.saleInfo) == JSON.stringify(this.props.saleInfo)) {
      return;
    }
    this.resetTimeState(nextProps.saleInfo);
  }

  componentWillUnmount() {
    if (this.timer) {
      window.clearInterval(this.timer)
    }
    ;
  }

  resetTimeState(saleInfo) {
    // 空
    let ydlpk = ['--', '--', '--']
    let xyft = ['--', '--', '--']
    const lottery01 = _.find(saleInfo, {lotteryid: 50});
    const lottery02 = _.find(saleInfo, {lotteryid: 34});
    const xyftTimer = lottery01 && lottery01.countdown;
    const ydlpkTimer = lottery02 && lottery02.countdown;
    const xyftCycle = lottery01 && lottery01.next_cycle;
    const ydlpkCycle = lottery02 && lottery02.next_cycle;
    if (ydlpkTimer == null) {
        ydlpk = ['--', '--', '--']
    }
    if (xyftTimer == null) {
        xyft = ['--', '--', '--']
    }

    // 正常情况
    if (ydlpkTimer >= 0) {
        ydlpk = UNIT.formatTime(ydlpkTimer).split(':');
    }
    if (xyftTimer >= 0) {
        xyft = UNIT.formatTime(xyftTimer).split(':')
    }
    this.countdown(ydlpkTimer, xyftTimer, ydlpkCycle, xyftCycle)

  }

  countdown(ydlpkTimer, xyftTimer, ydlpkCycle, xyftCycle) {
    const {action} = this.props;
    if (this.timer) {
      window.clearInterval(this.timer)
    }
    this.ydlpkTimer = ydlpkTimer;
    this.xyftTimer = xyftTimer;
    this.ydlpkCycle = ydlpkCycle;
    this.xyftCycle = xyftCycle;

    const intervalCountdown = function () {
      let ydlpk = ['--', '--', '--'];
      let xyft = ['--', '--', '--'];

      if (this.ydlpkTimer != null) {
        this.ydlpkTimer = this.ydlpkTimer > 0 ? this.ydlpkTimer - 1 : this.ydlpkCycle - 1;
          ydlpk = UNIT.formatTime(this.ydlpkTimer).split(':');
      }
      if (this.xyftTimer != null) {
        this.xyftTimer = this.xyftTimer > 0 ? this.xyftTimer - 1 : this.xyftCycle - 1;
          xyft = UNIT.formatTime(this.xyftTimer).split(':')
      }
      this.setState({
          xyft: xyft,
          ydlpk: ydlpk
      })

    }.bind(this)

    intervalCountdown();
    this.timer = window.setInterval(intervalCountdown, 1000)
  }

  // 立即投注
  handlePlayClick(id) {
    if (this.props.saleInfo.length === 0) {
      alert('数据加载中....');
      return;
    }
    const _lottery = _.find(this.props.saleInfo, {lotteryId: String(id)});
    if (!_lottery.is_sale) {
      alert('当前彩种未到销售时间');
      return;
    }
    if (window.METHODS.autheError) {
      alert(window.METHODS.autheError.message);
      return;
    }
    const lotteryMenu = _.find(_.concat(..._.map($.makeLott(LOTTERY_MENUS), 'lotterys')), {lotteryId: id});
    window.location.href = lotteryMenu.uri;
  }

  render() {
    return (
        <ul>
          <li>
            <p className="ydl10 mb30">
              <a href="#/lottery/animate/ydl10/1">
                <span>{_.join(this.state.ydlpk, ':')}</span>
                <button></button>
              </a>
            </p>
            <p className="hn5fc"><a href="#/lottery/ssc/hn5fc/cg"></a></p>
          </li>
          <li>
            <p className="txffc  mb30">
              <a href="#/lottery/ssc/txffc/cg"></a>
            </p>
            <p className="xyft">
              <a href="#/lottery/ssc/xyft/1">
                <span>{_.join(this.state.xyft, ':')}</span>
                <button></button>
              </a>
            </p>
          </li>
          <li>
            <p className="zryl"><a href="#/Casino"></a></p>
          </li>
          <li className='last'>
            <p className="tyjj">
                <a href="#/sports"></a>
                <span></span>
            </p>
            <p className="dz-ty">
              <a href="#/Slot"></a>
            </p>
          </li>
        </ul>
    )
  }
}